const KNOWN_MEDIA_FORMATS = new Set([
  'aac',
  'avi',
  'flac',
  'gif',
  'jpeg',
  'jpg',
  'm4a',
  'mkv',
  'mov',
  'mp3',
  'mp4',
  'ogg',
  'png',
  'quicktime',
  'tif',
  'tiff',
  'wav',
  'webm',
  'webp',
  'x-m4a',
  'x-wav',
]);
const MIME_TOP_LEVELS = new Set(['application', 'audio', 'image', 'video']);

function normalizeMediaFormatAlias(value: string): string {
  if (value === 'jpg') return 'jpeg';
  if (value === 'tif') return 'tiff';
  if (value === 'mpeg') return 'mp3';
  if (value === 'quicktime') return 'mov';
  if (value === 'x-m4a') return 'm4a';
  if (value === 'x-wav') return 'wav';
  return value;
}

export function isKnownMediaFormat(value: string): boolean {
  const normalized = normalizeMediaFormat(value);
  return Boolean(normalized && KNOWN_MEDIA_FORMATS.has(normalized));
}

export function normalizeMediaFormat(value: string): string {
  let normalized = value.trim().toLowerCase();
  if (!normalized) return '';

  normalized = normalized.split('#')[0] ?? '';
  normalized = normalized.split('?')[0] ?? '';
  normalized = normalized.split(';')[0] ?? '';
  normalized = normalized.trim();
  if (!normalized) return '';

  const slashParts = normalized.split('/');
  const isMimeType = slashParts.length === 2 && MIME_TOP_LEVELS.has(slashParts[0]);
  const isPathLike = normalized.includes('/') && !isMimeType;

  if (normalized.includes('/')) {
    normalized = slashParts.pop() ?? '';
  }
  if (isPathLike && !normalized.includes('.')) {
    return '';
  }
  if (normalized.includes('.')) {
    normalized = normalized.split('.').pop() ?? '';
  }
  normalized = normalized.trim();
  if (!normalized || normalized === '*') return '';

  return normalizeMediaFormatAlias(normalized);
}

export function getFileFormat(file: File): string {
  const mimeSubtype = file.type ? normalizeMediaFormat(file.type) : '';
  if (mimeSubtype) return mimeSubtype;

  const ext = file.name.split('.').pop();
  return ext ? normalizeMediaFormat(ext) : '';
}
